import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Badge } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { ButtonComponent } from "../elements";

export default function GastosTableComponent({ thead, tbody }) {
    const { t } = useContext(TranslatorContext);
    const [alertModal, setAlertModal] = useState(false);
    const [data, setData] = useState([]);

    useEffect(()=> { setData(tbody) }, [tbody]);

    const formatCurrency = (amount) => {
        const numAmount = typeof amount === 'string' ? 
            parseInt(amount.replace(/\./g, '')) : amount;
        
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0
        }).format(numAmount);
    };

    const getStatusBadge = (status, estado_class) => {
        const variants = {
            success: 'success',
            warning: 'warning', 
            danger: 'danger',
            info: 'info'
        };
        return <Badge bg={variants[estado_class] || 'secondary'}>{status}</Badge>;
    };

    const getCategoryColor = (category) => {
        const colors = {
            'Gastos Oficina': '#dc3545',
            'Edmundo Neira': '#0dcaf0',
            'Operativa/Terreno': '#198754',
            'Egresos Operativos': '#ffc107'
        };
        return colors[category] || '#6c757d';
    };

    return (
        <div className="mc-table-responsive">
            <table className="mc-table product">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead?.map((item, index) => (
                            <th key={ index }>{ t(item) }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={ index }> 
                            <td>
                                <span className="badge bg-light text-dark">{item.id}</span>
                            </td>
                            <td>
                                <div className="mc-table-product md">
                                    <div className="mc-table-group">
                                        <h6 className="mb-1">{ item.heading }</h6>
                                        <p className="mb-0 text-muted small">{ item.describe }</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex align-items-center">
                                    <div 
                                        className="me-2" 
                                        style={{
                                            width: '12px',
                                            height: '12px',
                                            backgroundColor: getCategoryColor(item.category),
                                            borderRadius: '2px'
                                        }}
                                    ></div>
                                    <span className="small">{ item.category }</span>
                                </div>
                            </td>
                            <td>
                                <span className="small">{ new Date(item.brand).toLocaleDateString('es-CL') }</span>
                            </td>
                            <td>
                                <strong style={{ color: getCategoryColor(item.category) }}>
                                    { formatCurrency(item.comuna) }
                                </strong>
                            </td>
                            <td>
                                <span className="small">{ item.responsable }</span>
                            </td>
                            <td>
                                { getStatusBadge(item.status, item.estado_class) }
                            </td>
                            <td>
                                <div className="mc-table-action">
                                    <Link to={`/gastos/ver/${item.id}`}>
                                        <ButtonComponent 
                                            className="material-icons" 
                                            type="button" 
                                            variant="outline-dark"
                                            title="Ver detalle"
                                        >
                                            {item.action.view}
                                        </ButtonComponent>
                                    </Link>
                                    
                                    {item.status === 'Pendiente' && (
                                        <Link to={`/gastos/validar/${item.id}`}>
                                            <ButtonComponent 
                                                className="material-icons ms-1" 
                                                type="button" 
                                                variant="outline-success"
                                                title="Validar gasto"
                                            >
                                                {item.action.approve}
                                            </ButtonComponent>
                                        </Link>
                                    )}
                                    
                                    <Link to={`/gastos/editar/${item.id}`}>
                                        <ButtonComponent 
                                            className="material-icons ms-1" 
                                            type="button" 
                                            variant="outline-warning"
                                            title="Editar"
                                        >
                                            {item.action.edit}
                                        </ButtonComponent>
                                    </Link>
                                    
                                    <ButtonComponent 
                                        className="material-icons ms-1" 
                                        type="button" 
                                        variant="outline-danger"
                                        title="Eliminar"
                                        onClick={() => setAlertModal(true)}
                                    >
                                        {item.action.delete}
                                    </ButtonComponent>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <Modal show={alertModal} onHide={() => setAlertModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Eliminación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    ¿Está seguro que desea eliminar este gasto? Esta acción no se puede deshacer.
                </Modal.Body>
                <Modal.Footer>
                    <ButtonComponent variant="secondary" onClick={() => setAlertModal(false)}>
                        Cancelar
                    </ButtonComponent>
                    <ButtonComponent variant="danger" onClick={() => setAlertModal(false)}>
                        Eliminar
                    </ButtonComponent>
                </Modal.Footer>
            </Modal>
        </div>
    );
}